import {
  ChecklistComplementaryItemPosition,
  checklistComplementaryItems,
} from '@/core/domain/workorder/WorkOrdersChecklist/WorkOrdersChecklist.ComplementaryItemsConstant';
import { Form, Table, Typography } from 'antd';
import complementItemsColumns from '../complementItemsColumns';
import {
  ChecklistComplementItemFields,
  ChecklistComplementItemResponse,
} from '@/core/domain/workorder/WorkOrdersChecklist/WorkOrdersChecklist.types';

const ChecklistComplementItemsTestRunList: React.FC = () => {
  const form = Form.useFormInstance();
  const items = Form.useWatch<ChecklistComplementItemFields[]>(
    'items-test-run',
    form,
  );

  const complementItems = checklistComplementaryItems.filter(
    (item) => item.position === ChecklistComplementaryItemPosition.TestRun,
  );

  function handleAllCheckbox(
    checked: boolean,
    responseType: ChecklistComplementItemResponse,
  ) {
    form.setFieldValue(
      'items-test-run',
      complementItems.map((item) => ({
        response: checked ? [responseType] : [],
        description: item.value,
      })),
    );
  }

  function handleAllSelected(responseType: ChecklistComplementItemResponse) {
    return (
      items?.length > 0 &&
      !!items?.every((item) =>
        item.response?.some((type) => type === responseType),
      )
    );
  }

  function handleAllIndeterminate(
    responseType: ChecklistComplementItemResponse,
  ) {
    return (
      items?.length > 0 &&
      !!items?.some((item) =>
        item.response?.some((type) => type === responseType),
      ) &&
      !items?.every((item) =>
        item.response?.some((type) => type === responseType),
      )
    );
  }

  return (
    <>
      <Typography.Title level={4}>
        Inspeção final e teste de rodagem
      </Typography.Title>

      <Form.List name="items-test-run">
        {() => (
          <Table
            pagination={false}
            dataSource={complementItems}
            columns={complementItemsColumns({
              listName: 'items-test-run',
              handleAllCheckbox,
              handleAllSelected,
              handleAllIndeterminate,
            })}
            scroll={{ x: true }}
          />
        )}
      </Form.List>
    </>
  );
};

export default ChecklistComplementItemsTestRunList;
